import { createContext, ReactNode, useContext } from 'react';

import { ApplicationErrorModal } from 'components/modal/ApplicationErrorModal';
import { useClientFonts } from 'hooks/client/useClientFonts';
import { Client, useQueryApplicationClient } from 'hooks/client/useQueryApplicationClient';

type ClientContext = Client & {
    reloadFonts: () => void;
};

const ClientContext = createContext<ClientContext>({} as ClientContext);

export function ClientProvider({ children }: { children: ReactNode }) {
    const { data, isFetching, isError } = useQueryApplicationClient();
    const { reloadFonts } = useClientFonts(data?.name);

    // enquanto não possui os dados do cliente, não renderiza nada a não ser o loader da aplicação.
    if (isFetching) return null;

    if (isError || !data) return <ApplicationErrorModal type="client" />;

    return <ClientContext.Provider value={{ ...data, reloadFonts }}>{children}</ClientContext.Provider>;
}

export const useClientContext = (): ClientContext => useContext(ClientContext);
